<!-- @format -->
<!-- 资源树 -->

<template>
	<pc-container :title="title" class="type-attr-resTree">
		<template v-if="isEdit" #extra>
			<el-icon class="type-attr-resTree-extra" @click.stop.prevent="() => onShowDiaLog('add')"><Plus /></el-icon>
		</template>

		<el-input v-model="filterText" placeholder="搜索" @keyup.enter="onSearch" />
		<el-tree
			ref="treeRef"
			v-loading="resList.loading"
			class="filter-tree"
			:data="resList.data"
			:props="defaultProps"
			default-expand-all
			node-key="objectid"
			highlight-current
			:filter-node-method="filterNode"
			:allow-drop="allowDrop"
			:indent="8"
			v-bind="$attrs"
			@node-drop="handleDrop"
		>
			<template #default="{ data }">
				<el-tooltip
					:content="`${data.resName}${showCount && data.resCount ? `(${data.resCount})` : ''}`"
					placement="top"
					:show-after="500"
				>
					<span class="custom-tree-node" @mouseover="hoverItemId = data.objectid" @mouseleave="hoverItemId = ''">
						<span
							:class="[
								'custom-tree-node-label',
								data.objectid === hoverItemId && isEdit ? 'custom-tree-node-hover-label' : '',
							]"
						>
							<img v-if="data.iconPath" :src="data.iconPath" class="custom-tree-node-label-img" />
							<span>
								{{ data.resName?.length > 12 ? `${data.resName.slice(0, 12)}...` : data.resName }}
								{{ showCount && data.resCount ? `(${data.resCount})` : '' }}
							</span>
						</span>

						<span v-if="data.objectid === hoverItemId && isEdit" class="custom-tree-node-utils">
							<!-- 资源项不可新增子项 -->
							<el-icon
								v-if="data.resType === '0'"
								class="type-attr-resTree-extra"
								@click.stop.prevent="() => onShowDiaLog('add', data)"
							>
								<Plus />
							</el-icon>

							<!-- 资源项添加复制按钮 -->
							<el-icon
								v-if="data.resType === '1'"
								class="type-attr-resTree-extra"
								@click="() => onShowDiaLog('copy', data)"
							>
								<CopyDocument />
							</el-icon>

							<el-icon class="type-attr-resTree-extra" @click.stop.prevent="() => onShowDiaLog('edit', data)">
								<Edit />
							</el-icon>

							<!-- 根节点不可删除，二级目录有资源项不可删除 -->
							<template v-if="data.children.length === 0 && (!data.ifLock ? true : data.ifLock === '0')">
								<el-icon class="type-attr-resTree-extra" @click.stop.prevent="() => onDelRes(data)">
									<Delete />
								</el-icon>
							</template>
						</span>
					</span>
				</el-tooltip>
			</template>
		</el-tree>

		<el-dialog
			v-model="dialogVal.visibled"
			:title="`${dialogVal.type === 'add' ? '新增' : dialogVal.type === 'edit' ? '编辑' : '复制'}`"
			width="40%"
			append-to-body
			@close="onClose"
		>
			<el-form ref="formRef" :model="dialogVal.form" label-position="right" label-width="auto">
				<template v-for="item in resConfigList.filter((i) => !i.hidden)" :key="item.code">
					<el-form-item
						:label="item.label"
						:prop="item.code"
						:rules="
							item.code === 'lockReason'
								? dialogVal.form['ifLock'] === '1'
									? [{ required: true, message: '请输入锁定原因', trigger: 'blur' }]
									: []
								: item.rules
						"
					>
						<template #label>
							<div>
								{{ item.label }}
								<pc-help-tip v-if="item.helpTips" type="tooltip" :content="item.helpTips" placement="top-start" />
							</div>
						</template>
						<slot></slot>
						<template v-if="item.type === 'input'">
							<el-input
								v-model="dialogVal.form[item.code]"
								:placeholder="`请输入${item.label}`"
								:clearable="true"
								:disabled="
									dialogVal.type === 'add'
										? false
										: item.code === 'resCode'
										? dialogVal.form['ifLock'] === '1'
											? true
											: false
										: false
								"
							/>
						</template>

						<template v-else-if="item.type === 'textarea'">
							<el-input
								v-model="dialogVal.form[item.code]"
								:placeholder="`请输入${item.label}`"
								:clearable="true"
								:rows="2"
								type="textarea"
							/>
						</template>

						<template v-else-if="item.type === 'radio'">
							<el-radio-group
								v-model="dialogVal.form[item.code]"
								:disabled="item.disabled"
								@change="(val) => handleRadioChange(val, item.code)"
							>
								<el-radio v-for="itm in item.params" :key="itm.label" :label="itm.label">
									{{ itm.value }}
								</el-radio>
							</el-radio-group>
						</template>

						<template v-else-if="item.type === 'checkbox'">
							<el-checkbox-group v-model="dialogVal.form[item.code]" :disabled="item.disabled">
								<el-checkbox v-for="itm in item.params" :key="itm.label" :label="itm.value">
									{{ itm.label }}
								</el-checkbox>
							</el-checkbox-group>
						</template>

						<template v-else-if="item.type === 'image'">
							<el-col :span="12" class="upload-icon">
								<el-form-item label="" prop="appIcon">
									<div>
										<span class="photo-area" @click="dialogFormVisibleimg = !readonly">
											<img v-if="resources && resources.appIcon" :src="resources.appIcon" class="avatar" />
											<el-icon v-else class="avatar-uploader-icon">
												<Plus />
											</el-icon>
											<div
												v-if="!readonly"
												:class="resources && resources.appIcon !== '' ? 'handle-photo-buttons' : null"
												@click.stop="
													() => {
														dialogFormVisibleimg = false;
													}
												"
											>
												<div v-if="resources && resources.appIcon !== ''">
													<el-icon @click.stop="dialogFormVisibleimg = !readonly">
														<Edit />
													</el-icon>
													<el-icon @click.stop="resources.appIcon = ''">
														<Delete />
													</el-icon>
												</div>
											</div>
										</span>
									</div>
									<pcp-uploader-image
										:visible="dialogFormVisibleimg"
										:limit="1"
										:accept="acceptTypeLogo"
										:is-history="true"
										:is-my="'N'"
										:folder-alias="'base_subsys_pic'"
										@action-event="uploaderAction"
										@close="(visible) => (dialogFormVisibleimg = visible)"
									/>
								</el-form-item>
							</el-col>
						</template>
					</el-form-item>
				</template>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button type="primary" :loading="dialogVal.loading" @click="onSave(formRef)">保存</el-button>
					<el-button :loading="dialogVal.loading" @click="onClose">取消</el-button>
				</span>
			</template>
		</el-dialog>
	</pc-container>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import { type FormInstance, type FormItemRule, type ElTree, ElMessage } from 'element-plus';
	import { getFilePreviewUrlById } from '@power/runtime-vue3';
	import type Node from 'element-plus/es/components/tree/src/model/node';
	import type { NodeDropType } from 'element-plus/es/components/tree/src/tree.type';
	import { PcContainer, PcModal, PcHelpTip } from '@/components';
	import { PcpUploaderImage } from '@/p-components/pcp-uploader-image/index';
	import { getResList, addRes, editRes, delRes, orderRes } from '@/api/resource';
	import { testStrOrNumOr_ } from '@/utils';
	import { getDicts } from '@/api/dict/data';

	interface Props {
		title: string; // 容器title
		isEdit?: boolean; // 是否可编辑
		showCount?: boolean; // 是否展示count
		bussinessCode: string; // 业务分类
	}
	// props
	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['onCopy']);

	// initialValue
	interface ResList {
		loading: boolean; // 是否loading
		data: any[]; // 资源树数据
	}

	interface DiaLogVal {
		type: 'add' | 'edit' | 'copy'; // 是否编辑
		visibled: boolean; // 是否展示
		loading: boolean; // 是否loading
		item: any | null; // 展示是哪条数据的
		form: {
			resType: '0' | '1';
			resCode: string;
			resName: string;
			ifQrCode: '0' | '1';
			iconPath: string;
			ifLock: '0' | '1';
			menuList: any;
			resourceRepositoryInfo: any;
			lockReason: string;
		}; // 框内form表单数据
	}

	const initDialogVal = (): DiaLogVal => ({
		type: 'add',
		visibled: false,
		loading: false,
		item: null,
		form: {
			resType: '0',
			resCode: '',
			resName: '',
			ifQrCode: '0',
			iconPath: '',
			ifLock: '0',
			menuList: [],
			resourceRepositoryInfo: [],
			lockReason: '',
		},
	});

	interface ResConfigList {
		code: string;
		label: string;
		type: 'radio' | 'input' | 'image' | 'checkbox' | 'textarea';
		disabled: boolean;
		hidden?: boolean;
		params?: { label: string; value: string }[];
		rules?: FormItemRule[];
		helpTips?: string;
	}

	const initResConfigList = (): ResConfigList[] => [
		{
			code: 'resType',
			label: '节点类型',
			type: 'radio',
			disabled: false,
			params: [
				{
					label: '0',
					value: '分类',
				},
				{
					label: '1',
					value: '配置项',
				},
			],
		},
		{
			code: 'resName',
			label: '节点名称',
			type: 'input',
			disabled: false,
			rules: [
				{ required: true, message: '请输入节点名称', trigger: 'blur' },
				{ max: 32, message: '节点名称最多32位' },
			],
		},
		{
			code: 'resCode',
			label: '节点code',
			type: 'input',
			disabled: false,
			rules: [
				{ required: true, message: '请输入节点编码', trigger: 'blur' },
				{ max: 32, message: '节点编码最多32位' },
				{ validator: validateResCode, trigger: 'blur' },
			],
		},
		{
			code: 'ifQrCode',
			label: '是否生成二维码',
			type: 'radio',
			disabled: false,
			hidden: true,
			params: [
				{
					label: '0',
					value: '否',
				},
				{
					label: '1',
					value: '是',
				},
			],
		},
		{
			code: 'menuList',
			label: '资源信息',
			type: 'checkbox',
			disabled: false,
			hidden: true,
			params: menuList.value,
			helpTips: '在资源实例呈现时，展示关联信息',
		},
		{
			code: 'resourceRepositoryInfo',
			label: '资源仓库',
			type: 'checkbox',
			disabled: false,
			hidden: true,
			params: resourceRepositoryInfo.value,
			// helpTips: '在资源实例呈现时，展示关联信息',
		},
		{
			code: 'ifLock',
			label: '是否锁定',
			type: 'radio',
			hidden: true,
			disabled: false,
			helpTips: '模型锁定，模型编码不可修改，模型不可删除',
			params: [
				{
					label: '0',
					value: '否',
				},
				{
					label: '1',
					value: '是',
				},
			],
		},
		{
			code: 'lockReason',
			label: '锁定原因',
			type: 'textarea',
			hidden: true,
			disabled: false,
		},
		{
			code: 'iconPath',
			label: '资源图标',
			type: 'image',
			disabled: false,
		},
	];

	const validateResCode = (_: any, value: string, callback: any) => {
		if (!testStrOrNumOr_(value)) {
			callback(new Error('请输入数字字母或下划线'));
		} else {
			callback();
		}
	};
	//上传相关代码
	const dialogFormVisibleimg = ref(false);

	const acceptTypeLogo = ref('.jpg,.jpeg,.png');
	const resources = ref({
		//绑定的值
		appIcon: '',
	});
	const readonly = ref(false); //true：只读，false:添加编辑

	const uploaderAction = (buttonKey, data) => {
		resources.value.appIcon = getFilePreviewUrlById(data[0]);
		dialogFormVisibleimg.value = false;
	};

	// el-tree-ref
	const treeRef = ref<InstanceType<typeof ElTree>>();
	// form-ref
	const formRef = ref<FormInstance>();
	const isIfLockEdit = ref(0);

	// 文本框数据
	const filterText = ref<string>('');

	const menuList: any = ref([]);
	// 资源仓库信息
	const resourceRepositoryInfo: any = ref([]);

	// tree数据
	const resList = ref<ResList>({
		loading: false,
		data: [],
	});

	// dialog框参数
	const dialogVal = ref<DiaLogVal>(initDialogVal());

	// dialog框内组件
	const resConfigList = ref<ResConfigList[]>(initResConfigList());

	// 鼠标移入的资源项
	const hoverItemId = ref<string>('');

	// tree-props
	const defaultProps = {
		children: 'children',
		label: 'resName',
		isLeaf: (data: any) => data.resType === '1',
	};

	// action

	// tree-filter方法
	const filterNode = (value: string, data) => {
		if (!value) return true;
		return data.resName.toLocaleLowerCase().includes(value.toLocaleLowerCase());
	};

	// 文本search方法
	const onSearch = () => {
		treeRef.value!.filter(filterText.value);
	};

	const handleRadioChange = (val, code) => {
		if (code === 'ifLock') {
			if (val === '0') {
				isIfLockEdit.value++;
				if (isIfLockEdit.value <= 3 && dialogVal.value.type !== 'add') {
					dialogVal.value.form.ifLock = '1';
					PcModal.PcMessageBox({
						title: '系统提示',
						message: `已锁定的模型无法修改${
							dialogVal.value.form.lockReason ? `,锁定原因:${dialogVal.value.form.lockReason}` : ''
						}`,
						type: 'warning',
					})
						.then(async ({ done }) => {
							done();
						})
						.catch(({ done }) => {
							done();
						});
				}
			} else {
				isIfLockEdit.value = 0;
			}
		}
	};

	// 获取resList方法
	const getResLists = () => {
		resList.value.loading = true;
		getResList({ bussinessCode: props.bussinessCode }).then((res: any) => {
			if (res.code === 200) {
				resList.value = {
					data: res.rows,
					loading: false,
				};
			}
		});
	};

	const getTreeData = () => resList.value;

	// 打开dialog框
	const onShowDiaLog = (type: DiaLogVal['type'], item?: DiaLogVal['item']) => {
		isIfLockEdit.value = 0;

		// 设置打开dialog框且赋基础值
		dialogVal.value = {
			...dialogVal.value,
			type,
			visibled: true,
		};
		// 重置dialog框内组件结构
		// 点击头部新增事件，或者编辑时需要禁止resType选择
		if (['edit', 'copy'].includes(type) || !item) {
			resConfigList.value = initResConfigList().map((itm) =>
				itm.code === 'resType' ? { ...itm, disabled: true } : itm,
			);
		} else {
			resConfigList.value = initResConfigList();
		}
		// 有item则为tree中点击的事件,需要展示所有参数
		if (item) {
			dialogVal.value = {
				...dialogVal.value,
				item,
			};
			const {
				resType,
				resCode,
				resName,
				ifQrCode,
				iconPath,
				ifLock = '0',
				menuList = '',
				resourceRepositoryInfo = '',
				lockReason,
			} = item;
			if (type === 'edit') {
				dialogVal.value.form = {
					resType,
					resCode,
					resName,
					ifQrCode,
					iconPath,
					ifLock,
					lockReason,
					menuList: menuList ? menuList.split(',') : [],
					resourceRepositoryInfo: resourceRepositoryInfo ? resourceRepositoryInfo.split(',') : [],
				};
				if (dialogVal.value.form.iconPath.split('id=')[1] !== 'null') {
					resources.value.appIcon = dialogVal.value.form.iconPath;
				} else {
					resources.value.appIcon = '';
				}
			} else if (type === 'copy') {
				dialogVal.value.form = {
					resType,
					resCode: `${resCode}_copy`,
					resName: `${resName}_copy`,
					ifQrCode,
					iconPath,
					ifLock,
					lockReason,
					menuList,
					resourceRepositoryInfo,
				};
			} else {
				resources.value.appIcon = '';
			}
		} else {
			resources.value.appIcon = '';
		}
	};

	// 新增或编辑资源项
	const onSave = (formEl: FormInstance | undefined) => {
		formEl!.validate(async (valid) => {
			if (valid) {
				dialogVal.value.loading = true;

				const objectid = dialogVal.value.item?.objectid || '-1';
				const pid = dialogVal.value.item?.pid || '-1';
				dialogVal.value.form.iconPath = resources.value.appIcon;
				try {
					const res: any =
						dialogVal.value.type === 'add'
							? await addRes({
									bussinessCode: props.bussinessCode,
									...dialogVal.value.form,
									pid: objectid,
									menuList: dialogVal.value.form.menuList.join(','),
									resourceRepositoryInfo: dialogVal.value.form.resourceRepositoryInfo.join(','),
							  })
							: dialogVal.value.type === 'copy'
							? await addRes({
									bussinessCode: props.bussinessCode,
									...dialogVal.value.form,
									pid,
									menuList: dialogVal.value.form.menuList.join(','),
									resourceRepositoryInfo: dialogVal.value.form.resourceRepositoryInfo.join(','),
							  })
							: await editRes({
									bussinessCode: props.bussinessCode,
									...dialogVal.value.form,
									pid,
									objectid,
									menuList: dialogVal.value.form.menuList.join(','),
									resourceRepositoryInfo: dialogVal.value.form.resourceRepositoryInfo.join(','),
							  });

					if (res.code === 200) {
						getResLists();
						if (dialogVal.value.type === 'copy') {
							emit('onCopy', res.data.objectid);
						} else {
							ElMessage({
								message: dialogVal.value.type === 'add' ? '新增成功' : '编辑成功',
								type: 'success',
							});
						}
					}
					onClose();
				} finally {
					dialogVal.value.loading = false;
				}
			}
		});
	};

	// 删除资源项
	const onDelRes = (data) => {
		PcModal.PcMessageBox({
			title: '系统提示',
			message: '请确认是否删除',
			type: 'warning',
		})
			.then(async ({ done }) => {
				try {
					const res: any = await delRes({ bussinessCode: props.bussinessCode, objectid: data.objectid });
					if (res.code === 200) {
						getResLists();
						ElMessage({
							message: '删除成功',
							type: 'success',
						});
					}
				} finally {
					done();
				}
			})
			.catch(({ done }) => {
				done();
			});
	};

	// 重置dialog框数据
	const onClose = () => {
		dialogVal.value = initDialogVal();
	};

	// 拖拽
	const allowDrop = (_: Node, dropNode: Node, type: NodeDropType) => {
		// 若为叶子结点则不可拖入
		const isLeaf = dropNode.data.resType === '1' && type === 'inner';

		// 叶子节点不能拖动到根目录
		const ifLeafToBase = _.data.resType === '1' && dropNode.data.pid === '-1' && type !== 'inner';
		if (isLeaf || ifLeafToBase) {
			return false;
		} else {
			return true;
		}
	};

	// 拖拽成功
	const handleDrop = async (_: Node, dropNode: Node, dropType: NodeDropType) => {
		const obj = {
			objectid: _.data.objectid,
			parentid: dropType === 'inner' ? dropNode.data.objectid : dropNode.data.pid,
			previd: dropType === 'inner' ? 0 : dropNode.data.objectid,
			type: dropType === 'after' ? 1 : 0,
		};

		resList.value.loading = true;
		const res: any = await orderRes({ bussinessCode: props.bussinessCode, ...obj });
		if (res.code === 200) {
			_.data.pid = obj.parentid;
			resList.value.loading = false;

			ElMessage({
				message: '更新成功',
				type: 'success',
			});
		}
	};
	const getMenuList = async () => {
		const res = await getDicts('modelinfo');
		menuList.value =
			res &&
			res.map((item) => {
				return {
					label: item.label,
					value: item.value,
				};
			});
	};
	// 获取资源仓库信息
	const getResourceInfoList = async () => {
		const res = await getDicts('zyckxx');
		resourceRepositoryInfo.value =
			res &&
			res.map((item) => {
				return {
					label: item.label,
					value: item.value,
				};
			});
	};

	watch(
		() => dialogVal.value.form.resType,
		(newVal) => {
			resConfigList.value.map((item) => {
				if (
					item.code === 'ifQrCode' ||
					item.code === 'menuList' ||
					item.code === 'ifLock' ||
					item.code === 'lockReason' ||
					item.code === 'resourceRepositoryInfo'
				) {
					item.hidden = newVal === '0';
				}
			});
		},
		{
			immediate: true,
		},
	);

	// mounted
	// 初次渲染时获取数据
	getResLists();
	getMenuList();
	getResourceInfoList();

	defineExpose({ treeRef, getResList: getResLists, getTreeData });
</script>

<style scoped lang="scss">
	.type-attr-resTree {
		width: 250px;
		height: 100%;

		.filter-tree {
			margin-top: 5px;
			height: calc(100% - 40px);
			overflow-y: scroll;

			:deep(.el-tree-node__content) {
				width: 100%;

				.el-tree-node__label {
					width: calc(100% - 24px);
				}
			}
		}

		.type-attr-resTree-extra {
			cursor: pointer;
			margin-right: 2px;
		}

		.custom-tree-node {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 14px;

			.custom-tree-node-label {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				.custom-tree-node-label-img {
					width: 1em;
					height: 1em;
					margin-right: 2px;
				}
			}

			.custom-tree-node-hover-label {
				width: calc(100% - 50px);
			}

			.custom-tree-node-utils {
				display: flex;
				width: 50px;
			}
		}
	}
</style>
<style scoped lang="scss">
	//上传样式
	.upload-icon {
		height: 120px;
	}

	.operation {
		height: 16px;
		line-height: 16px;
		margin-bottom: 10px;
		display: block;
		float: left;
		position: absolute;
		left: -75px;
		color: #606266;
	}

	.photo-area {
		border-radius: 10px;
		background-color: #f5f8fa;
		display: block;
		width: 100px !important;
		height: 100px !important;
		z-index: 997;

		.avatar {
			display: block;
			width: 100px !important;
			height: 100px !important;
		}
	}

	.handle-photo-buttons {
		position: absolute;
		top: 0;
		background: rgba(7, 0, 0, 0.6);
		width: 100px;
		height: 100px;
		display: none;
		z-index: 998;

		> div {
			margin: 44% 0 0 30%;

			i {
				z-index: 999;
				cursor: pointer;
				margin: -10px 4px;
				color: white;
				font-size: 18px;
			}
		}
	}

	.photo-area:hover > .handle-photo-buttons {
		display: block;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #e0e8ed;
		width: 100px !important;
		height: 100px !important;
		line-height: 100px !important;
		text-align: center;
		border: 1px dashed transparent;
		border-radius: 10px;
		background: linear-gradient(#f5f8fa, #f5f8fa) padding-box,
			repeating-linear-gradient(-45deg, #ccc 0, #ccc 0.15em, white 0, white 0.25em);
	}
</style>
